import { render, staticRenderFns } from "./Edit-News-Events.vue?vue&type=template&id=32743d6a&scoped=true"
import script from "./Edit-News-Events.vue?vue&type=script&lang=js"
export * from "./Edit-News-Events.vue?vue&type=script&lang=js"
import style0 from "./Edit-News-Events.vue?vue&type=style&index=0&id=32743d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32743d6a",
  null
  
)

export default component.exports